export default __webpack_public_path__ + "static/media/help.73165e19.svg";